import { Type } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { ClientError } from '../core/client-error.js';
import { CLIENT_ERRORS } from '../registry.js';
export function httpToClientError(body) {
    if (typeof body !== 'object' || body === null)
        return undefined;
    const { type } = body;
    if (typeof type !== 'string')
        return undefined;
    const descriptor = CLIENT_ERRORS[type];
    if (!descriptor)
        return undefined;
    const schema = Type.Object({
        type: Type.Literal(descriptor.type),
        data: descriptor.dataSchema,
    });
    if (!Value.Check(schema, body))
        return undefined;
    const { data } = body;
    return new ClientError({ type: descriptor.type, data });
}
